export default "__VITE_ASSET__DCUIYPm7__"